import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "app-cases-cell-renderer",
  templateUrl: "./cases-cell-renderer.component.html",
  styleUrls: ["./cases-cell-renderer.component.scss"],
})
export class CasesCellRendererComponent implements OnInit, OnDestroy {
  params: any;
  cases:number;
  notes: FormControl = new FormControl();
  poItemNote: FormControl = new FormControl();
  private destroy$ = new Subject<void>();

  constructor(private dialog: MatDialog) {}

  agInit(params: any): void {
    this.params = params;
   // const casesQty= params.data.qtyPerCase ? (params.data.qty - (params.data.receivedQty / params.data.qtyPerCase)) : params.data.qty;
   // this.cases=Number.isInteger(casesQty) ? casesQty : casesQty.toFixed(2);
   this.notes.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(value => {
     if (value) {
       this.params.callbackFunction(value, this.params);
     }
   });
   this.poItemNote.valueChanges.subscribe(value => {
     if (value) {
       this.params.callbackFunction(value, this.params);
     }
   });
  }
  
  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
